import AccountsGetStarted from '../GetStarted/AccountsGetStarted'

const AddAccountsPrompt = ({
    className
}) => {
    return (
        <div className={`text-center ${className}`}>
            <h3 className="text-center spc-m-t-1 spc-m-b-2">
                Add Accounts
            </h3>
            
            <AccountsGetStarted />
        </div>
    )
}

export default AddAccountsPrompt